const Page = (props) => {
    return (
        <div className={(props.hash === props.id) ? 'page current' : ((props.oldHash === props.id) ? 'page old' : 'page hidden')} id={props.id}>
            {props.children}
        </div>
    );

}

export default Page;